import { render, staticRenderFns } from "./confirm-reserve.vue?vue&type=template&id=65621d4e&lang=pug&"
import script from "./confirm-reserve.vue?vue&type=script&lang=js&"
export * from "./confirm-reserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports